module.exports = __webpack_public_path__ + "static/media/model-l200-06.9d8d7924.jpg";